import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getCardiacSelector } from '../selectors'
import { CardiacConstants } from '../store/cardiac.constants'
import { ICardiacState } from '../store/cardiac.types'

export function* setProcedureComplications() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const cardiacState: ICardiacState = yield select(getCardiacSelector)
  const { inputRows } = procedureState
  const { procedureComplications } = cardiacState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === CardiacConstants.SET_PROCEDURE_COMPLICATIONS) {
        //@ts-ignore
        input.props.savedValues = procedureComplications
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setProcedureComplicationsSaga() {
  yield takeLatest([CardiacConstants.SET_PROCEDURE_COMPLICATIONS], setProcedureComplications)
}
